import { ColumnBase } from './column-base';
import { isBlank, getDeepValue, getDateValue, formatDBTZDateToLocalDate, getPOLQAValue } from '../../common/utils';
import { DataType } from './types';
import { SelectItem } from '../../common';
import { CommonFilterService } from 'src/app/shared/services/common-filter/common-filter.service';

export class Column extends ColumnBase {

  index: number;
  filterValuesTemp: SelectItem[] = [];
  left: number;

  get containsDots(): boolean {
    return (this.name.indexOf('.') >= 0);
  }

  get isDateType(): boolean {
    return (this.type === 'date' || this.type === 'datetime-local' || this.type === 'month');
  }

  dbTz = -500;
  db_BrDiff = -500;
  mainFilterTZ = 0;
  constructor(init: Partial<ColumnBase>, DB_TZ?: number, DB_BRDiff?: number, mainFilterTZ?: number) {//, private commonFilterService: CommonFilterService
    super();
    this.dbTz = DB_TZ;
    //console.log(DB_TZ)
    this.db_BrDiff = DB_BRDiff;
    //console.log(DB_BRDiff)
    this.mainFilterTZ = mainFilterTZ;
    //console.log(MainFilterID)
    Object.assign(this, init);
    this.setDefaults();
  }

  private setDefaults() {
    if (!this.width) {
      this.width = 108; //column width default settings - IMP
      ////GetMapColumAllia IMP to give spaces between units and headers
      if (this.title !== undefined) {
      //  //this.width = this.title.length * 4;
      //  //if (this.title.length <= 10 && this.title.indexOf(' ') === -1)
        //  //  this.width = this.title.length * 9;
        //console.log(this.title)
        if (this.title === 'Event ID' || this.title === 'Call Event Condition')
          this.width = 300;
        else if (this.title === 'Called Number')
          this.width = 180;
        else if (this.title === 'Call ID' || this.title === 'Device ID' || this.title === 'PHONEINFO IMEI' || this.title === 'Call Control Event')
          this.width = 180;//120;
        else if (this.title.indexOf('Timestamp') !== -1 || this.title === 'Latitude' || this.title === 'Longitude' || this.title === 'Degraded Filename'
          || this.title === 'Dropout')
          this.width = 70;
        else if (this.title === 'EModel (R-factor)')
          this.width = 60;
      //  else {
          ////https://stackoverflow.com/questions/49432789/angular-translate-using-replace-in-an-interpolation-string-in-html 
          //this.title = this.title.replace(/\s/g, '<br/>'); // Giving breaks similar to webviewer old - IMP
          //this.title = this.title.replace('Call<br/>Type', 'Call Type');
          //this.title = this.title.replace('<br/>-<br/>', ' - ');
      //  }
      //  //this.title = this.title.replace('VQuad', '<b>VQuad</b>');
      }
    }
    if (this.width < this.minWidth) {
      this.width = 108;//this.minWidth;
    }
    if (this.width > this.maxWidth) {
      this.width = this.maxWidth;
    }
    //this.width += 5;//extra gap for filter and sort icons - IMP

    if (!this.type) {
      if (this.options) {
        this.type = 'select';
      } else {
        this.type = 'text';
      }
    }
    if (!this.dataType) {
      if (this.isDateType) {
        this.dataType = DataType.Date;
      } else if (this.type === 'number') {
        this.dataType = DataType.Number;
        this.width = 60;
        if (this.title === 'Psophometric Noise (dBm)' || this.title === 'C-Message Noise (dBm)' || this.title.indexOf('Retransmit') !== -1 || this.title.indexOf('Downstream') !== -1)
          this.width = 80;
      }
    }
  }

  getOptions(dependsValue?: any): SelectItem[] {
    if (this.options) {
      if (this.dependsColumn && dependsValue) {
        return this.options.filter((value) => value.parentId === dependsValue);
      } else {
        return this.options;
      }
    }
  }

  getOptionName(value: any, dependsValue?: any) {
    const options = this.getOptions(dependsValue);
    if (!options || isBlank(value)) {
      return value;
    }
    const el = options.find(o => o.id.toString() === value.toString());
    return (el) ? el.name : null;
  }

  validate(value: any): string[] {
    if (this.validatorFunc && this.editable) {
      return this.validatorFunc(this.title, value);
    }
    return [];
  }

  setWidth(width: number) {
    if (width <= this.minWidth) {
      width = this.minWidth;
    } else if (width >= this.maxWidth) {
      width = this.maxWidth;
    }
    this.width = width;
  }

  getValue(row: any) {
    //console.log(row[this.name] + this.containsDots + this.name)
    if (!row) {
      return '';
    }
    if (this.containsDots) {
      return getDeepValue(row, this.name);
    } else {
      if (this.name.indexOf("_Timestamp") != -1 || this.name.indexOf("_TimeStamp") != -1) {
        //console.log(this.dbTz)

        ////let dbTz1 = -500;
        ////this.commonFilterService.DB_TZ.subscribe(res => {
        ////  //dbTz1 = res;
        ////  console.log(res)
        ////});
        return formatDBTZDateToLocalDate(getDateValue(row, this.name), this.dbTz, this.db_BrDiff, this.mainFilterTZ);
      }
      else if (this.name == "POLQA_Score" || this.name == "POLQA_v3") {
        return getPOLQAValue(row, this.name);
      }
      return row[this.name];
    }
  }

  getValueView(row: any) {
    let value = this.getValue(row);
    const dependsValue = row[this.dependsColumn] ? row[this.dependsColumn] : null;
    if (value) {
      value = this.getOptionName(value, dependsValue);
    }
    if (this.pipe) {
      value = this.pipe.transform(value);
    }
    return value;
  }

  getFilterValues(): Promise<SelectItem[]> {
    if (this.filterValues && typeof this.filterValues === 'function') {
      return this.filterValues(this.name);
    } else if (this.filterValues && this.filterValues instanceof Array) {
      return Promise.resolve(this.filterValues);
    } else if (this.options) {
      return Promise.resolve(this.options);
    }
    return Promise.resolve([]);
  }

}
